const inventoryRoutes = {
	ubicaciones: {
		path: '/ubicaciones',
		name: 'Ubicaciones',
		component: () => import('@/views/Ubicaciones.vue'),
		meta: { title: 'Ubicaciones', adminOnly: true }
	},
	crearUbicacion: {
		path: '/ubicacion',
		name: 'CrearUbicacion',
		component: () => import('@/views/Ubicacion.vue'),
		meta: { title: 'Crear ubicación', adminOnly: true }
	},
	editarUbicacion: {
		path: '/ubicacion/:id',
		name: 'EditarUbicacion',
		component: () => import('@/views/Ubicacion.vue'),
		meta: { title: 'Editar ubicación', adminOnly: true }
	},
	entradas: {
		path: '/entradas',
		name: 'Entradas',
		component: () => import('@/views/Entradas.vue'),
		meta: { title: 'Entradas' }
	},
	crearEntrada: {
		path: '/entrada',
		name: 'CrearEntrada',
		component: () => import('@/views/Entrada_Salida.vue'),
		meta: { title: 'Crear Entrada' }
	},
	salidas: {
		path: '/salidas',
		name: 'Salidas',
		component: () => import('@/views/Salidas.vue'),
		meta: { title: 'Salidas' }
	},
	ventas: {
		path: '/ventas',
		name: 'Ventas',
		component: () => import('@/views/Ventas.vue'),
		meta: { title: 'Salidas (Por Ubicación)' }
	},
	crearSalida: {
		path: '/salida',
		name: 'CrearSalida',
		component: () => import('@/views/Entrada_Salida.vue'),
		meta: { title: 'Crear Salida' }
	},
	revisarSalidas: {
		path: '/revisar_salidas',
		name: 'RevisarSalidas',
		component: () => import('@/views/Revisar_Salidas.vue'),
		meta: { title: 'Revisar Salidas' }
	},
	traspasos: {
		path: '/transfers',
		name: 'Transfers',
		component: () => import('@/views/Transfers.vue'),
		meta: { title: 'Transfers' }
	},
	traspaso: {
		path: '/transfer/:transfer_id',
		name: 'Transfer',
		component: () => import('@/views/Imprimir_Transfer.vue'),
		meta: { title: 'Transfer' }
	},
	crearTraspaso: {
		path: '/transfer',
		name: 'CrearTransfer',
		component: () => import('@/views/Transfer.vue'),
		meta: { title: 'Crear Transfer' }
	},
	planearTraspaso: {
		path: '/pending-transfer',
		name: 'CreatePendingTransfer',
		component: () => import('@/views/CreatePendingTransfer.vue'),
		meta: { title: 'Planear Transfer' }
	},
	pendingTransfer: {
		path: '/pending-transfer/:pending_transfer_id',
		name: 'PendingTransfer',
		component: () => import('@/views/PendingTransfer.vue'),
		meta: { title: 'Detalles Transfer Pendiente' }
	},
	crearMultiTraspaso: {
		path: '/multi_transfer',
		name: 'MultiTransfer',
		component: () => import('@/views/Multi_Transfer.vue'),
		meta: { title: 'Crear Multi-transfer' }
	},
	inventario: {
		path: '/inventario',
		name: 'Inventario',
		component: () => import('@/views/Inventario.vue'),
		meta: { title: 'Inventario' }
	},
	ajustes: {
		path: '/ajustes',
		name: 'Ajustes',
		component: () => import('@/views/Ajustes.vue'),
		meta: { title: 'Ajustes de inventario' }
	},
	actualizarInventarioRetail: {
		path: '/actualizar-inventario-retail',
		name: 'ActualizarInventarioRetail',
		component: () => import('@/views/Actualizar_Inventario.vue'),
		meta: { title: 'Actualizar Inventario' }
	},
	actualizarInventario: {
		path: '/actualizar-inventario',
		name: 'ActualizarInventario',
		component: () => import('@/views/Actualizar_Inventario.vue'),
		meta: { title: 'Actualizar Inventario' }
	},
	extracciones: {
		path: '/extracciones',
		name: 'Extracciones',
		component: () => import('@/views/Extracciones.vue'),
		meta: { title: 'Extracciones' }
	},
	suscripcionesCharges: {
		path: '/inventory-planning',
		name: 'SuscripcionesCharges',
		component: () => import('@/views/SuscripcionesCharges.vue'),
		meta: { title: 'Inventory Planning' }
	}
}

export default inventoryRoutes
